// Smart Magenta -- filtro da listagem. Multi-selecao por grupo (varios
// valores dentro do mesmo filtro = OU; grupos diferentes = E). ASCII puro.
(function () {
  var raiz = document.getElementById('sm-filtros');
  if (!raiz) return;
  var hits = [].slice.call(document.querySelectorAll('#sm-col-grid .sm-hit'));
  var contagem = document.getElementById('sm-col-n');
  var vazio = document.getElementById('sm-col-vazio');
  var sel = { abertura: [], preco: [], porta: [], marca: [] };

  function tem(el, campo, v) {
    return el.getAttribute('data-' + campo).split(' ').indexOf(v) >= 0;
  }
  function casaGrupo(el, campo) {
    var vs = sel[campo];
    if (!vs.length) return true;
    for (var i = 0; i < vs.length; i++) { if (tem(el, campo, vs[i])) return true; }
    return false;
  }
  function casa(el) {
    return casaGrupo(el, 'abertura') && casaGrupo(el, 'preco') &&
           casaGrupo(el, 'porta') && casaGrupo(el, 'marca');
  }
  function pinta() {
    var n = 0;
    for (var i = 0; i < hits.length; i++) {
      var ok = casa(hits[i]);
      hits[i].style.display = ok ? '' : 'none';
      if (ok) n++;
    }
    contagem.textContent = n;
    vazio.classList.toggle('sm-oculto', n > 0);
    atualizaContador();
  }
  raiz.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-f]');
    if (!b) return;
    var campo = b.getAttribute('data-f'), v = b.getAttribute('data-v');
    var i = sel[campo].indexOf(v);
    if (i >= 0) { sel[campo].splice(i, 1); b.setAttribute('aria-pressed', 'false'); }
    else { sel[campo].push(v); b.setAttribute('aria-pressed', 'true'); }
    pinta();
  });
  var limpa = document.getElementById('sm-col-limpa');
  if (limpa) {
    limpa.addEventListener('click', function () {
      sel = { abertura: [], preco: [], porta: [], marca: [] };
      var bts = raiz.querySelectorAll('[data-f]');
      for (var i = 0; i < bts.length; i++) { bts[i].setAttribute('aria-pressed', 'false'); }
      pinta();
    });
  }

  // No celular os filtros abrem e fecham num botao: empilhados, empurravam
  // o primeiro produto pra quase duas telas de rolagem. O contador no
  // botao mostra quantos filtros estao ativos mesmo com o painel fechado.
  var abre = document.getElementById('sm-filtros-abre');
  var painel = document.getElementById('sm-filtros');
  var contaBt = document.getElementById('sm-filtros-n');
  if (abre && painel) {
    abre.addEventListener('click', function () {
      var fechado = painel.classList.toggle('sm-filtros-fechado');
      abre.setAttribute('aria-expanded', String(!fechado));
    });
  }
  function atualizaContador() {
    if (!contaBt) return;
    var n = 0;
    for (var k in sel) { if (sel.hasOwnProperty(k)) { n += sel[k].length; } }
    contaBt.textContent = n ? '(' + n + ')' : '';
  }

  // Descricao recolhida no celular: o texto inteiro fica no HTML (busca e
  // IA leem tudo), mas quem quer ver produto nao rola tres telas antes.
  var intro = document.getElementById('sm-col-intro');
  var maisBt = document.getElementById('sm-col-mais');
  if (intro && maisBt) {
    maisBt.addEventListener('click', function () {
      var recolhido = intro.classList.toggle('sm-recolhido');
      maisBt.textContent = recolhido ? 'Ler mais' : 'Ler menos';
    });
  }
})();